import { connect } from 'react-redux';

import {
  alerts,
  getIsSessionProgressTableLoading,
  getSessionProgressTableData,
  getSessionProgressTableDate,
  getSignedBlob,
  isLoadingSignedBlob,
  loadingAlerts,
  navigationOptions,
  objectNames,
} from 'core/selectors';
import {
  getAllMetadata,
  getSessionProgressTable,
  signBlob
} from 'core/slices/pipelineMonitoring';
import { getAlerts } from 'core/slices/serviceMonitoring';

import PipelineMonitoringTable from '../../../components/pipelineMonitoring/PipelineMonitoringTable';

export default connect(
  (state) => ({
    objectNames: objectNames(state),
    navigationOptions: navigationOptions(state),
    alerts: alerts(state),
    loadingAlerts: loadingAlerts(state),
    signedBlob: getSignedBlob(state),
    isLoadingSignedBlob: isLoadingSignedBlob(state),
    sessionProgressTableData: getSessionProgressTableData(state),
    isSessionProgressTableLoading: getIsSessionProgressTableLoading(state),
    sessionProgressTableDate: getSessionProgressTableDate(state),
  }),
  {
    signBlob,
    getAlerts,
    getAllMetadata,
    getSessionProgressTable,
  }
)(PipelineMonitoringTable);
